import { DirectAudienceMember_OfficeGroup } from '@ms/yammer-graphql';

import { OfficeGroup } from '../../../state/types';

type ProcessOfficeGroup = (value: DirectAudienceMember_OfficeGroup) => OfficeGroup;
export const processOfficeGroup: ProcessOfficeGroup = ({ id, displayName, memberCount, type, officeGroupEmail }) => ({
  id,
  name: displayName,
  memberCount,
  type,
  email: officeGroupEmail,
});
